import { MUIcon } from '@platform/shared/ui';
import React from 'react';

const WorkingLayerMenuTrigger: React.FC = () => (
  <div className="flex h-[36px] w-[36px] items-center justify-center rounded-lg shadow-none hover:bg-gray-100">
    <MUIcon name="more_horiz" className="text-gray-600" />
  </div>
);

export default WorkingLayerMenuTrigger;
